import {CallJs} from "../../lib/types";

type Params =
	{
		page_title: string
		super_user: boolean
		page: string
		window_width: string
		window_height: string
		popup_width: string
		popup_height: string
		on_background: string
		outside_navigation: string
		dir_new_image: string
		dir_short_label: string
		file_image: string
		file_short_label: string
		arrow_image: string
		version_short_label: string
	}

type State =
	{
		window_num: number //todo confirm: local or shared state? assumed shared, likely local
		max_window_num: number
		displaying_previous_view: boolean
	}

type KeyParams = {
	super_user: string
	outside_navigation: string
	page: string
}

type RemoveBrowserElementsParams = string[]
export const removeBrowserElements: CallJs<RemoveBrowserElementsParams> = (replace, params) =>  {
	params.map(p => window.opener.remove_browser_window_element(p))
}

type RefreshParams = {
	window_num: number,
	parent_id: string,
	parent_is_directory: boolean,
	id: string|null
}[]
export const refreshWindows: CallJs<RefreshParams> = (replace, params) =>  {
	params.map(p => {
		const r: WindowRefresher = window.opener.refresh_window
		r(p.window_num, p.parent_id, p.parent_is_directory, p.id)
	}
		)
	self.close()
}

export const initializeKeyJavascript: CallJs<KeyParams> = (replace, params) =>
{
	var super_user = params.super_user;

	// record_type key
	// 0 = File
	// 1 = Directory
	// 3 = Version
	window.set_delete_id = function (id: string, record_type: string)
	{
		const ele = document.getElementById('memory_delete_id')
		if(ele)
		ele.innerHTML = id + '-' + record_type;
	}

	const delete_record = function (id: number|string)
	{
		if (id != '')
		{
			const http = new XMLHttpRequest();

			var url = params.page + '?command=get_confirm_delete_message&id=' + id + params.outside_navigation;
			http.open("GET", url, true);

			http.onreadystatechange = function()
			{
				if (http.readyState == 4)
				{
					if (http.responseText.length > 0)
					{
						if (confirm('Are you sure you want to delete this record?'))
						{
							if (confirm(http.responseText))
							{
								if (confirm('THIS ACTION CANNOT BE UNDONE!\nAre you sure you want to delete these records?'))
								{
									document.location.assign(params.page + '?command=delete&id=' + id + params.outside_navigation);
								}
							}
						}
					}
					else
					{
						alert('Permission denied');
					}
				}
			}
			http.send(null);
		}
	}
	window.delete_record = delete_record

	window.on_key_down = function (code: number)
	{
		let id: number|string = 0;

		// Capture delete key
		if (code == 46)
		{
			// Passed from one of the iframs
			const ele = document.getElementById('memory_delete_id')
			if(ele)
				id = ele.innerHTML;
			delete_record(id);
		}
	}

}

export const doit: CallJs<Params> = (replace, params) => {
	const state: State = {
		window_num: 0,
		max_window_num: 0,
		displaying_previous_view: false,
	}
	window.refresh_window = refresh_window(params)
	window.add_browser_window = add_browser_window(params, state)
	window.revert_browser = revert_browser
	window.remove_browser_window_element = remove_browser_window_element
}

function remove_browser_window_element(my_count: number)
{
	if (document.getElementById('browser_window_' + my_count))
	{
		var tr_elm = document.getElementById("outer_tr");
		var rm_td = document.getElementById("browser_window_" + my_count);
		if (tr_elm && rm_td)
		{
			tr_elm.removeChild(rm_td);
		}
	}
}

function revert_browser(url: string)
{
	parent.document.location.assign(url);
}

const add_browser_window = (params: Params, state: State) => function (
	new_window_num: number,
	parent_id: string,
	parent_is_directory_any: boolean|string|number,
	id: string,
	command: string,
	parent_name: string,
	dir_is_writeable: boolean,
	file_is_writeable: boolean
)
{
	const parent_is_directory: number = parent_is_directory_any == 1 || parent_is_directory_any == 'true' ? 1 : 0 //remarkably, this works. we use a number to try avoid the 'true'/'false' string
	if(id == undefined) id = ''
	if (new_window_num == 1)
	{
		parent_name = params.page_title;
		if (params.super_user)
		{
			dir_is_writeable = true;
			file_is_writeable = true;
		}
		else
		{
			dir_is_writeable = false;
			file_is_writeable = false;
		}
	}

	// Change the global variable so that it can be used in the event handler
	state.window_num = new_window_num;

	// Add outer table
	if (!document.getElementById('outer_table'))
	{
		var new_table = document.createElement("TABLE");
		new_table.setAttribute('id','outer_table');
		new_table.setAttribute('cellpadding','0');
		new_table.setAttribute('cellspacing','0');
		new_table.setAttribute('border','0');
		document.body.appendChild(new_table);

		const new_tbody = document.createElement("TBODY");
		new_tbody.setAttribute('id','outer_tbody');
		const table_elm = document.getElementById("outer_table");
		if(table_elm)
			table_elm.appendChild(new_tbody);

		const new_tr = document.createElement("TR");
		new_tr.setAttribute('id','outer_tr');
		const tbody_elm = document.getElementById("outer_tbody"); //todo redundant
		if(tbody_elm)
			tbody_elm.appendChild(new_tr);
	}

	if (state.window_num > state.max_window_num)
	{
		state.max_window_num = state.window_num;
	}
	else if (state.window_num <= state.max_window_num)
	{
		for(let i = state.window_num; i <= state.max_window_num; i++)
		{
			remove_browser_window_element(i);
		}

		if (!state.displaying_previous_view)
		{
			state.max_window_num = state.window_num;
		}

	}

	// Hide add links for windows other than this one
	if (state.max_window_num > 1)
	{
		for(let i = 1; i < state.max_window_num; i++)
		{
			if (document.getElementById('tr_' + i))
			{
				const ele = document.getElementById('tr_' + i)
				if(ele) ele.style.visibility = 'hidden';
			}
		}
	}


	if (!document.getElementById('browser_window_' + state.window_num))
	{
		{
			const new_td = document.createElement("TD");
			new_td.setAttribute('id', 'browser_window_' + state.window_num);
			new_td.setAttribute('valign', 'top');
			const tr_elm = document.getElementById("outer_tr");
			if (tr_elm) tr_elm.appendChild(new_td);
		}

		{
			const new_div = document.createElement("div");
			new_div.setAttribute("className", "fieldset_title");
			new_div.setAttribute("class", "fieldset_title");
			const div_text = document.createTextNode(parent_name.substring(0, 24));
			new_div.appendChild(div_text);

			const new_link = document.createElement("a");
			new_link.setAttribute("style", "text-decoration: none;");

			var revert_url = "" + params.page + "?command=revert_browser&window_num=" + state.window_num + params.outside_navigation;
			new_link.setAttribute("href", "javascript:revert_browser('" + revert_url + "');");
			new_link.appendChild(new_div);
			new_div.setAttribute('style', 'padding:3px;margin:0px;');

			const td_elm = document.getElementById('browser_window_' + state.window_num);
			if(td_elm) td_elm.appendChild(new_link);
		}

		var new_url = params.page + '?command=' + command + '&window_num=' + state.window_num + '&parent_is_directory=' + parent_is_directory + '&parent_id=' + parent_id + '&id=' + id + '&dir_is_writeable=' + dir_is_writeable + '&file_is_writeable=' + file_is_writeable + '&parent_name=' + parent_name;

		const idhm = 'browser_frame_' + state.window_num
		const id_td_lm = 'browser_window_' + state.window_num

		var new_iframe = document.createElement("IFRAME");
		new_iframe.setAttribute('id',idhm);
		new_iframe.setAttribute('name','browser_frame_' + state.window_num);
		new_iframe.setAttribute('width', params.window_width);
		new_iframe.setAttribute('height', params.window_height);
		new_iframe.setAttribute('border','0');
		new_iframe.setAttribute('src',new_url);
		new_iframe.setAttribute('style','border: 1px solid ' + params.on_background + '; padding:0');
		const add_args = '?window_num=' + state.window_num + '&parent_is_directory=1&parent_id=' + parent_id;
		const add_url = params.page + add_args;

		const dir_url     = add_url + '&command=display_directory_form';
		const file_url    = add_url + '&command=display_file_form';
		const version_url = params.page + "/display_version_form" + add_args;

		{
			const td_elm = document.getElementById(id_td_lm);
			if(td_elm)
			td_elm.appendChild(new_iframe);

			const new_table = document.createElement("TABLE");
			new_table.setAttribute('id', 'table_' + state.window_num);
			new_table.setAttribute('cellpadding', '1');
			new_table.setAttribute('cellspacing', '1');
			new_table.setAttribute('border', '0');
			new_table.setAttribute('align', 'center');
			if(td_elm)
			td_elm.appendChild(new_table);
		}

		{
			const new_tbody = document.createElement("TBODY");
			new_tbody.setAttribute('id', 'tbody_' + state.window_num);
			const table_elm = document.getElementById('table_' + state.window_num);
			if(table_elm)
			table_elm.appendChild(new_tbody);
		}

		{
			const new_tr = document.createElement("TR");
			new_tr.setAttribute('id', 'tr_' + state.window_num);
			const tbody_elm = document.getElementById('tbody_' + state.window_num);
			if(tbody_elm)
			tbody_elm.appendChild(new_tr);
		}

		{
			const new_td = document.createElement("TD");
			new_td.setAttribute('id', 'td_1_' + state.window_num);
			new_td.setAttribute('valign', 'top');
			new_td.setAttribute('height', '20');
			const tr_elm = document.getElementById('tr_' + state.window_num);
			if(tr_elm) tr_elm.appendChild(new_td);
			new_td.setAttribute('valign', 'middle');
		}

		if ((dir_is_writeable  || file_is_writeable ) && ((state.window_num == state.max_window_num) || (state.window_num == 1)))
		{
			if (parent_is_directory)
			{
				if (dir_is_writeable)
				{
					const new_image = document.createElement("img");
					new_image.setAttribute("src", params.dir_new_image);
					new_image.setAttribute("border", "0");

					{
						const new_link = document.createElement("a");
						new_link.setAttribute("href", "javascript:new_window('" + dir_url + "'," + params.popup_width + "," + params.popup_height + ")");
						new_link.appendChild(new_image);

						const td_elm = document.getElementById('td_1_' + state.window_num);
						if(td_elm) td_elm.appendChild(new_link);
					}

					{
						const new_td = document.createElement("TD");
						new_td.setAttribute('id', 'td_2_' + state.window_num);
						new_td.setAttribute('valign', 'top');
						const tr_elm = document.getElementById('tr_' + state.window_num);
						if (tr_elm) tr_elm.appendChild(new_td);
						new_td.setAttribute('valign', 'middle');
					}

					{
						const new_link = document.createElement("a");
						const link_text = document.createTextNode("Add " + params.dir_short_label);
						new_link.setAttribute("href", "javascript:new_window('" + dir_url + "'," + params.popup_width + "," + params.popup_height + ")");
						new_link.appendChild(link_text);

						const td_elm = document.getElementById('td_2_' + state.window_num);
						if (td_elm) td_elm.appendChild(new_link);
					}
				}

				if (file_is_writeable)
				{
					{
						const new_td = document.createElement("TD");
						new_td.setAttribute('id', 'td_3_' + state.window_num);
						new_td.setAttribute('valign', 'top');
						const tr_elm = document.getElementById('tr_' + state.window_num);
						if (tr_elm) tr_elm.appendChild(new_td);
						new_td.setAttribute('valign', 'middle');
					}

					{
						const new_image = document.createElement("img");
						new_image.setAttribute("src", params.file_image);
						new_image.setAttribute("border", "0");

						const new_link = document.createElement("a");
						new_link.setAttribute("href", "javascript:new_window('" + file_url + "'," + params.popup_width + "," + params.popup_height + ")");
						new_link.appendChild(new_image);

						const td_elm = document.getElementById('td_3_' + state.window_num);
						if(td_elm) td_elm.appendChild(new_link);
					}

					{
						const new_td = document.createElement("TD");
						new_td.setAttribute('id', 'td_4_' + state.window_num);
						new_td.setAttribute('valign', 'top');
						const tr_elm = document.getElementById('tr_' + state.window_num);
						if (tr_elm) tr_elm.appendChild(new_td);
						new_td.setAttribute('valign', 'middle');
					}

					{
						const new_link = document.createElement("a");
						const link_text = document.createTextNode("Add " + params.file_short_label);
						new_link.setAttribute("href", "javascript:new_window('" + file_url + "'," + params.popup_width + "," + params.popup_height + ")");
						new_link.appendChild(link_text);

						const td_elm = document.getElementById('td_4_' + state.window_num);
						if(td_elm) td_elm.appendChild(new_link);
					}
				}
			}
			else if (file_is_writeable)
			{
				{
					const new_image = document.createElement("img");
					new_image.setAttribute("src", params.arrow_image);
					new_image.setAttribute("border", "0");

					const new_link = document.createElement("a");
					new_link.setAttribute("href", "javascript:new_window('" + version_url + "'," + params.popup_width + "," + params.popup_height + ")");
					new_link.appendChild(new_image);

					const td_elm = document.getElementById('td_1_' + state.window_num);
					if (td_elm) td_elm.appendChild(new_link);
				}

				{
					const new_td = document.createElement("TD");
					new_td.setAttribute('id', 'td_2_' + state.window_num);
					new_td.setAttribute('valign', 'top');
					const tr_elm = document.getElementById('tr_' + state.window_num);
					if(tr_elm) tr_elm.appendChild(new_td);
					new_td.setAttribute('valign', 'middle');
				}

				{
					const new_link = document.createElement("a");
					const link_text = document.createTextNode("Add New " + params.version_short_label);
					new_link.setAttribute("href", "javascript:new_window('" + version_url + "'," + params.popup_width + "," + params.popup_height + ")");
					new_link.appendChild(link_text);

					const td_elm = document.getElementById('td_2_' + state.window_num);
					if (td_elm) td_elm.appendChild(new_link);
				}
			}
		}
	}

	parent.window.frames['my_frame'].focus();
	parent.window.frames['my_frame'].scrollBy(params.window_width + 20, 0);
}

type WindowRefresher = (window_num: number, parent_id: string, parent_is_directory: boolean, id: string|null) => void

const refresh_window = (params: Params): WindowRefresher =>
	function (window_num: number, parent_id: string, parent_is_directory: boolean, id: string|null)
{
	const my_frame = 'browser_frame_' + window_num;

	if (document.getElementById(my_frame))
	{
		const frame_elm = document.getElementById(my_frame);
		if(frame_elm)
		frame_elm.setAttribute('src',params.page + '?command=get_session_window_data&window_num=' + window_num + '&parent_is_directory=' + parent_is_directory + '&parent_id=' + parent_id + '&id=' + id);
	}
}




// WEBPACK FOOTER //
// ./src/memory/component/single-upload.ts